import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  padding-top: 80px;
`;

export const TopPanel = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 80px;
  padding: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  overflow-x: auto;
  gap: 10px;
  align-items: center;
  background: linear-gradient(135deg, #4c0f0a, #1e1e1e);
  z-index: 1000;
  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    background: #ff7f50;
    border-radius: 4px;
  }
`;

export const MenuItem = styled.button`
  min-width: 180px;
  height: 40px;
  padding: 0 20px;
  border: none;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  white-space: nowrap;
  border-radius: 4px;
  transition: all 0.3s ease;
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const Content = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
`;

export const Form = styled.form`
  width: 50%;
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Input = styled.input`
  margin: 10px;
  width: 200px;
  height: 30px;
`;

export const Select = styled.select`
  margin: 10px;
  width: 200px;
  height: 30px;
`;

export const SubmitInput = styled.input`
  padding: 12px;
  width: 150px;
  border-radius: 25px;
  font-weight: 600;
  background: #ff7f50;
  color: white;
  border: none;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background: #ff5722;
  }
`;

export const Error = styled.div`
  color: red;
`;

export const Success = styled.div`
  color: green;
`;
